import { apiClient } from "./client";
import type {
  TestScenario,
  TestScenarioCreate,
  TestScenarioUpdate,
  TestScenariosPaginated,
  TestScenarioRunResult,
  TestScenarioRunAllResult,
  AllSimulatorsTestResult,
  MessageResponse,
} from "@/types";

// List test scenarios for a version
export async function listTestScenarios(
  versionId: number,
  page = 1,
  pageSize = 50
): Promise<TestScenariosPaginated> {
  const response = await apiClient.get<TestScenariosPaginated>(
    `/simulators/versions/${versionId}/test-scenarios`,
    { params: { page, page_size: pageSize } }
  );
  return response.data;
}

// Get a test scenario by ID
export async function getTestScenario(
  scenarioId: number
): Promise<TestScenario> {
  const response = await apiClient.get<TestScenario>(
    `/simulators/test-scenarios/${scenarioId}`
  );
  return response.data;
}

// Create a test scenario
export async function createTestScenario(
  versionId: number,
  data: TestScenarioCreate
): Promise<TestScenario> {
  const response = await apiClient.post<TestScenario>(
    `/simulators/versions/${versionId}/test-scenarios`,
    data
  );
  return response.data;
}

// Update a test scenario
export async function updateTestScenario(
  scenarioId: number,
  data: TestScenarioUpdate
): Promise<TestScenario> {
  const response = await apiClient.patch<TestScenario>(
    `/simulators/test-scenarios/${scenarioId}`,
    data
  );
  return response.data;
}

// Delete a test scenario
export async function deleteTestScenario(
  scenarioId: number
): Promise<MessageResponse> {
  const response = await apiClient.delete<MessageResponse>(
    `/simulators/test-scenarios/${scenarioId}`
  );
  return response.data;
}

// Delete multiple test scenarios at once
export async function deleteMultipleTestScenarios(
  versionId: number,
  ids: number[]
): Promise<MessageResponse> {
  const params = new URLSearchParams();
  ids.forEach((id) => params.append("ids", String(id)));
  const response = await apiClient.delete<MessageResponse>(
    `/simulators/versions/${versionId}/test-scenarios?${params.toString()}`
  );
  return response.data;
}

// Run a single test scenario
export async function runTestScenario(
  scenarioId: number
): Promise<TestScenarioRunResult> {
  const response = await apiClient.post<TestScenarioRunResult>(
    `/simulators/test-scenarios/${scenarioId}/run`
  );
  return response.data;
}

// Run all test scenarios for a version
export async function runAllTestScenarios(
  versionId: number
): Promise<TestScenarioRunAllResult> {
  const response = await apiClient.post<TestScenarioRunAllResult>(
    `/simulators/versions/${versionId}/test-scenarios/run-all`
  );
  return response.data;
}

// Run all test scenarios for all active simulators (latest published version)
export async function runAllSimulatorsTests(): Promise<AllSimulatorsTestResult> {
  const response = await apiClient.post<AllSimulatorsTestResult>(
    `/simulators/run-all-tests`
  );
  return response.data;
}

